(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxClassDetailController', TaxClassDetailController);

    TaxClassDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TaxClass'];

    function TaxClassDetailController($scope, $rootScope, $stateParams, entity, TaxClass) {
        var vm = this;
        vm.taxClass = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:taxClassUpdate', function(event, result) {
            vm.taxClass = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
